'use client';

import { Dialog } from '@headlessui/react';
import { cn } from '@lib/util/cn';
import { Button } from '@modules/common/components/button';
import { XClose } from '@modules/common/icons';

type Props = {
  isDismissible: boolean;
  onClose: () => void;
};

const ModalHeader = ({ isDismissible, onClose }: Props) => (
  <div className="flex shrink-0 items-center justify-between border-b border-brand-neutral-200 px-4 pt-2 pb-[9px]">
    <Dialog.Title
      className={cn(
        'font-heading font-light text-lg leading-[1.125] tracking-[-0.01em] text-brand-neutral-900',
        !isDismissible && 'py-3',
      )}
    >
      Cookie Settings
    </Dialog.Title>
    {isDismissible && (
      <Button
        variant="ghost"
        size="md"
        onClick={onClose}
        aria-label="Close cookie settings"
        className="size-11 hover:bg-transparent p-0 [&_svg]:size-6"
      >
        <XClose />
      </Button>
    )}
  </div>
);

export default ModalHeader;
